export function calendarMonths(startYear) {
  return Array.from({ length: 12 }, (_, i) => {
    const monthIdx = (6 + i) % 12;
    const year = i < 6 ? startYear : startYear + 1;
    const d = new Date(year, monthIdx, 1);
    return {
      label: d.toLocaleString('en-GB', { month: 'long', year: 'numeric' }),
      short: d.toLocaleString('en-GB', { month: 'short' }),
      key: `${year}-${String(monthIdx + 1).padStart(2, '0')}`,
    };
  });
}

export function formatCalDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T12:00:00');
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}
